import { Factory } from 'rosie';

Factory.define('AgentProfileEditor').attr('name', 'AGENT_PROFILE_EDITOR');

Factory.define('AgentProfileEditorWithDefaults').extend('AgentProfileEditor');



// WEBPACK FOOTER //
// ./factories/location/agent_profile_editor.js